import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/icons/close.svg'
import _imports_1 from '@/assets/gray_arrow.svg'


const _hoisted_1 = {
  key: 0,
  class: "flex justify-center items-center fixed inset-y-0 right-0 overflow-x-hidden overflow-y-hidden z-50 w-full"
}
const _hoisted_2 = { class: "flex relative w-1/2 h-auto" }
const _hoisted_3 = { class: "flex flex-col bg-white w-full max-h-screen rounded-2xl shadow p-8 overflow-y-auto" }
const _hoisted_4 = { class: "flex flex-row justify-between mb-8" }
const _hoisted_5 = {
  key: 0,
  class: "font-semibold text-lg"
}
const _hoisted_6 = {
  key: 1,
  class: "font-semibold text-lg"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "w-full relative" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "flex flex-row justify-between items-center" }
const _hoisted_12 = {
  key: 0,
  class: "text-gray-400"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col mr-6" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1)
const _hoisted_14 = {
  key: 0,
  class: "absolute flex flex-col bg-white shadow rounded w-full h-72 overflow-y-auto p-1 z-50"
}
const _hoisted_15 = {
  key: 0,
  class: "p-4"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, "No users found...", -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "flex flex-col mt-4" }
const _hoisted_20 = { class: "flex flex-col w-full mt-4" }
const _hoisted_21 = { class: "flex flex-row items-start mt-4" }
const _hoisted_22 = { class: "w-1/2 mr-2" }
const _hoisted_23 = { class: "flex flex-col w-1/2 ml-2" }
const _hoisted_24 = { class: "flex flex-row mt-4 items-center justify-srtart" }
const _hoisted_25 = { class: "flex flex-row rounded bg-gray-100 px-4 py-5 w-11/12 items-center justify-start" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6 text-gray-500",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"
  })
], -1)
const _hoisted_27 = {
  key: 0,
  class: "text-gray-400 ml-4"
}
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" Upload your receipt(s)... ")
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "text-error" }, "(Required)", -1)
const _hoisted_30 = [
  _hoisted_28,
  _hoisted_29
]
const _hoisted_31 = { class: "flex flex-row ml-4" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "flex flex-row items-center justify-center rounded-full px-6 ml-4 bg-primary py-3 hover:cursor-pointer hover:bg-primary-dark" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "text-white" }, "Upload", -1)
const _hoisted_35 = { class: "mt-4" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "h-px w-full bg-gray-300 my-4" }, null, -1)
const _hoisted_37 = { class: "flex flex-row justify-between mt-4" }
const _hoisted_38 = ["disabled"]
const _hoisted_39 = {
  key: 1,
  class: "bg-black opacity-50 fixed inset-y-0 right-0 z-40 w-full"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserCard = _resolveComponent("UserCard")!
  const _component_TextField = _resolveComponent("TextField")!
  const _component_SimpleSelect = _resolveComponent("SimpleSelect")!
  const _component_TextArea = _resolveComponent("TextArea")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.openModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                (!_ctx.blockUserEdit)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Add a new reimbursement request"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_6, "Edit reimbursement request")),
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                }, _hoisted_8)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedEmployees = !_ctx.selectedEmployees)),
                  class: "rounded bg-gray-100 pl-4 py-5 w-full disabled:cursor-not-allowed",
                  disabled: _ctx.blockUserEdit
                }, [
                  _createElementVNode("div", _hoisted_11, [
                    (!_ctx.selectedEmployeeId)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Select employee"))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", null, _toDisplayString(_ctx.selectedEmployeeName), 1),
                    _hoisted_13
                  ])
                ], 8, _hoisted_10),
                (_ctx.selectedEmployees)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      (_ctx.talent.length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.talent, (emp, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: i,
                          class: "flex flex-col"
                        }, [
                          _createElementVNode("button", {
                            onClick: ($event: any) => (_ctx.selectEmployee(i)),
                            class: "hover:bg-background-secondary rounded p-4 w-full"
                          }, [
                            _createVNode(_component_UserCard, {
                              firstName: emp.first_name,
                              lastName: emp.last_name,
                              position: emp.job_title
                            }, null, 8, ["firstName", "lastName", "position"])
                          ], 8, _hoisted_18)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_TextField, {
                  modelValue: _ctx.title,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.title) = $event)),
                  name: "title",
                  label: "Title",
                  error: _ctx.errors.title
                }, null, 8, ["modelValue", "error"]),
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_SimpleSelect, {
                    modelValue: _ctx.detail,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.detail) = $event)),
                    className: "bg-gray-100 rounded px-4 py-5 custom-select",
                    label: "Select a category",
                    options: _ctx.details
                  }, null, 8, ["modelValue", "options"])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_TextField, {
                      modelValue: _ctx.amount,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.amount) = $event)),
                      name: "amount",
                      label: "Amount",
                      error: _ctx.errors.amount
                    }, null, 8, ["modelValue", "error"])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(_component_SimpleSelect, {
                      modelValue: _ctx.currency,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.currency) = $event)),
                      className: "bg-gray-100 rounded px-4 py-5 custom-select-half w-full",
                      label: "Select a currency",
                      options: _ctx.currencies
                    }, null, 8, ["modelValue", "options"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _hoisted_26,
                    (_ctx.preview.length === 0 && _ctx.files.length === 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_27, _hoisted_30))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_31, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.preview, (name, i) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: i,
                          class: "mt-2 px-4 py-2 rounded-full text-gray-500 bg-gray-200 font-semibold text-sm flex flex-row align-center w-max cursor-not-allowed active:bg-gray-300 transition duration-300 ease"
                        }, _toDisplayString(name), 1))
                      }), 128))
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (file, i) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: i,
                        onClick: ($event: any) => (_ctx.viewReceipt(file.url)),
                        class: "mt-2 px-4 py-2 rounded-full text-gray-500 bg-gray-200 font-semibold text-sm flex align-center w-max cursor-pointer active:bg-gray-300 transition duration-300 ease ml-2"
                      }, _toDisplayString(file.identifier), 9, _hoisted_32))
                    }), 128))
                  ]),
                  _createElementVNode("label", _hoisted_33, [
                    _hoisted_34,
                    _createElementVNode("input", {
                      type: "file",
                      accept: "image/png, image/jpeg, application/pdf",
                      class: "hidden",
                      multiple: "",
                      onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.uploadFiles && _ctx.uploadFiles(...args)))
                    }, null, 32)
                  ])
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _createVNode(_component_TextArea, {
                    modelValue: _ctx.note,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.note) = $event)),
                    name: "note",
                    placeholder: "Write a note (Optional)"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _hoisted_36,
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("button", {
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
                  class: "btn-outline-lg"
                }, "Cancel"),
                _createElementVNode("button", {
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args))),
                  class: "btn-filled-lg disabled:opacity-75 disabled:cursor-not-allowed",
                  disabled: !_ctx.canSubmit
                }, _toDisplayString(_ctx.blockUserEdit ? "Save" : "Create"), 9, _hoisted_38)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.openModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_39))
      : _createCommentVNode("", true)
  ]))
}